<script>
  import { surveyStore } from '../../stores/surveyStore.js';
  import { getResultContent } from '../../utils/recommendationLogic.js';
  import { GA4Events } from '../../services/api.js';
  import config from '../../config.js';
  
  export let recommendation;
  
  $: content = getResultContent(recommendation.plan, recommendation.corporateFlag);
  
  function handleDeposit() {
    GA4Events.depositClicked(recommendation.plan);
    window.open(config.seatGeekUrl, '_blank');
  }
  
  function handleSendResults() {
    surveyStore.goToScreen('emailCapture', 5);
  }
  
  function handleKeepUpdated() {
    surveyStore.goToScreen('emailCaptureMarketing', 5);
  }
  
  function handleFAQ() {
    GA4Events.faqOpened();
    surveyStore.goToScreen('faq', 5);
  }
</script>

{#if recommendation.plan === 'undecided'}
  <!-- Undecided Result -->
  <div class="card">
    <div class="result-badge">{content.badge}</div>
    <h2 class="card-title" style="font-size:1.6rem">{@html content.title}</h2>
    <div class="card-body">
      {#each content.paragraphs as paragraph}
        <p>{paragraph}</p>
      {/each}
    </div>
    <div class="divider"></div>
    
    <div class="dual-cta">
      <button class="cta-primary" on:click={handleDeposit}>
        Hold my spot — $28/seat
      </button>
      <button class="cta-secondary" on:click={handleKeepUpdated}>
        Keep me updated
      </button>
    </div>
    <button class="cta-secondary" style="margin-top:0.5rem;width:100%" on:click={handleFAQ}>
      Not sure? Get in touch with our team →
    </button>
  </div>

{:else if recommendation.plan === 'premium'}
  <!-- Premium Result -->
  <div class="card">
    <div class="result-badge premium">{content.badge}</div>
    <h2 class="card-title" style="font-size:1.6rem">{@html content.title}</h2>
    <div class="card-body">
      {#each content.paragraphs as paragraph}
        <p>{paragraph}</p>
      {/each}
    </div>
    <div class="divider"></div>
    
    <button class="cta-primary premium" on:click={handleDeposit}>
      Reserve my premium priority →
    </button>
    <button class="cta-secondary" on:click={handleFAQ}>
      Have questions?
    </button>
  </div>

{:else}
  <!-- Full or Half Season Result -->
  <div class="card">
    <div class="card-eyebrow">{content.eyebrow}</div>
    
    <div class="result-header">
      <div class="result-plan-label">{@html content.planLabel}</div>
      <div class="result-based-on">{content.basedOn}</div>
    </div>
    
    <div class="result-description">{content.description}</div>
    
    <div class="result-section-label">What you get as a founding member</div>
    <ul class="benefit-check-list">
      {#each content.benefits as benefit}
        <li>
          <span class="check">✦</span>
          {benefit}
        </li>
      {/each}
    </ul>
    
    <p style="font-size:0.78rem;color:var(--muted);font-style:italic;margin-top:0.6rem;line-height:1.6">
      Additional membership benefits and perks will be announced ahead of the inaugural season.
    </p>
    
    <button class="cta-primary" on:click={handleDeposit}>
      Secure my seat — $28/seat →
    </button>
    <button class="cta-secondary" on:click={handleSendResults}>
      Send me my results
    </button>
    <button class="cta-secondary" on:click={handleFAQ}>
      Have questions?
    </button>
    
    <div class="divider"></div>
    
    <div class="result-section-label">
      What founding members are saying
    </div>
    <div class="quotes-wrap">
      {#each content.quotes as quote}
        <div class="quote-card">
          <div class="quote-text">{quote.text}</div>
          <div class="quote-attr">— {quote.attr}</div>
        </div>
      {/each}
    </div>
    
    <div class="stats-bar">
      <div class="stat-item">
        <span class="stat-number">8,000+</span>
        <span class="stat-label">Fans already in line</span>
      </div>
      <div class="stat-item">
        <span class="stat-number">Spring '27</span>
        <span class="stat-label">Seat selection opens</span>
      </div>
    </div>
    
    <div class="divider"></div>
    
    {#if recommendation.corporateFlag}
      <div style="margin-top:1.25rem;padding:0.85rem 1rem;background:rgba(0,80,181,0.06);border:1px solid rgba(0,80,181,0.2);border-radius:8px;font-size:0.78rem;color:var(--text-secondary)">
        <strong style="color:var(--primary)">Group interest noted.</strong> Your answers suggest a group or corporate purchase — a rep will be in touch about the group product when it becomes available. Your deposit still holds your priority in the meantime.
      </div>
    {/if}
  </div>
{/if}
